import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getReopenReasonAvailableColumns, getStatuses } from './api';

export const path = '/reopen-reason/list';

const PageReopenReasons: React.FC = (props) => {
  const ReopenReasons = Loadable.Map({
    loader: {
      page: () => import('./page'),
      statuses: getStatuses,
      columns: getReopenReasonAvailableColumns,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <ReopenReasons {...props} />;
};

export default PageReopenReasons;
